import { render, staticRenderFns } from "./ProfileAddSensorByQRCode.vue?vue&type=template&id=bc5706ac&scoped=true&"
import script from "./ProfileAddSensorByQRCode.vue?vue&type=script&lang=js&"
export * from "./ProfileAddSensorByQRCode.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAddSensorByQRCode.vue?vue&type=style&index=0&id=bc5706ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5706ac",
  null
  
)

export default component.exports